export default __webpack_public_path__ + "static/media/eligibility.86d28024.png";